import { render, staticRenderFns } from "./upload-picture.vue?vue&type=template&id=35621fe6&scoped=true&"
import script from "./upload-picture.vue?vue&type=script&lang=ts&"
export * from "./upload-picture.vue?vue&type=script&lang=ts&"
import style0 from "./upload-picture.vue?vue&type=style&index=0&id=35621fe6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35621fe6",
  null
  
)

export default component.exports